import type { I18nMessageObject } from '@_/types';
import type { DialogProps } from '@_/ui';
import { useRouter } from '@tanstack/react-router';
import { useCallback } from 'react';
import { AuthFlow } from '@_/components';
import { withDialog } from '@_/ui';
import { publicApiClient } from '#src/api.ts';
import { useStores } from '#src/state/StoreContext.tsx';

export const LoginDialog = withDialog(
  {
    showCloseButton: true
  },
  function LoginDialogContent({
    onOpenChange,
    onSuccess
  }: Pick<DialogProps, 'onOpenChange'> & {
    onSuccess?: () => void;
  }) {
    const router = useRouter();
    const { useAuthStore } = useStores();
    const login = useAuthStore(state => state.login);

    const initAuth = useCallback(async () => {
      await publicApiClient.auth.initAuth();
    }, []);

    const requestOTP = useCallback(
      async (data: { email: string }) => publicApiClient.auth.requestOtp({ body: data }),
      []
    );

    const verifyOTP = useCallback(
      async (data: { email: string; otp: string }) => login(data.email, data.otp),
      [login]
    );

    const updateProfile = useCallback(
      async (data: { name?: I18nMessageObject }) =>
        await publicApiClient.users.updateSelf({ body: data }),
      []
    );

    const handleSuccess = async () => {
      onOpenChange(false);
      onSuccess?.();
    };

    return (
      <>
        <AuthFlow
          endpoints={{
            initAuth,
            requestOTP,
            updateProfile,
            verifyOTP
          }}
          onSuccess={handleSuccess}
          privacyPolicyUrl={router.buildLocation({ to: '/{-$locale}/privacy-policy' }).href}
          termsOfUseUrl={router.buildLocation({ to: '/{-$locale}/terms' }).href}
        />
      </>
    );
  }
);
